<template>
    <im-select
        :multiple="true"
        :filterable="true"
        :loading="loading"
        :theme="theme"
        v-model:value="modelVal"
        :remote="true"
        :remoteMethod="onRemoteMethod"
        :isExact="isExact"
        :isSuggestion="true"
        :dropdownIcon="'icon-small-down'"
        v-outsideclick="hideDropdown"
        @toggle="handleToggle"
    >
        <template #place>
            <template v-if="!inMore">
                <div class="sug-pc-place" :class="labelClass">
                    <div class="desc">
                        <div>{{ tag }}</div>
                    </div>
                    <div class="icon" :class="{'rotate': isShowDropdown}">
                        <span class="iconfont icon-small-down"></span>
                    </div>
                </div>
            </template>
        </template>
        <template #default>
            <component
                :is="searchTag"
                :filter="[kee]"
                :hideRemoveAll="true"
                :inMore="true"
                :outSideSuggestion="true"
            />
            <im-option-group
                :key="index"
                v-for="(option, index) in options"
                :label="option.label"
            >
                <im-option
                    v-for="item in option.data"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                />
            </im-option-group>
        </template>

        <!-- </template> -->
    </im-select>
</template>

<script>
import mixin from './mixins';
import { suggestionOutTag } from '@/common/search-tag-list';
import SearchTagStandard from '../../standard/search-tag';
import SearchTagTemplate1 from '../../template1/search-tag';
import SearchTagTempalte4 from '../../template4/search-tag';
import SearchTagBroker from '../../broker/search-tag';
import classNames from 'classnames';

export default {
    emits: ['change'],
    name: 'SuggestionPc',
    mixins: [mixin],
    props: {
        inMore: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        searchTag() {
            switch (this.theme) {
            case 'standard':
                return SearchTagStandard;
            case 'template1':
                return SearchTagTemplate1;
            case 'template4':
                return SearchTagTempalte4;
            case 'broker': 
                return SearchTagBroker;
            default:
                return SearchTagStandard;
            }
        },
        tag() {
            return suggestionOutTag(this.value, this.kee, this.data);
        },
        labelClass({ theme, value, isShowDropdown }) {
            let temp = []
            if (value.length > 0 || isShowDropdown) {
                temp.push('active')
            }
            return classNames(theme, temp);
        },
        modelVal: {
            get() {
                return this.value || [];
            },
            set(val) {
                this.$emit('change', {
                    value: val,
                    kee: this.kee,
                    type: 'suggestion'
                });
            }
        }
    },
    data() {
        return {
            isShowDropdown: false
        }
    },
    methods: {
        hideDropdown() {
            this.isShowDropdown = false;
        },
        handleToggle(isShowDropdown) {
            this.isShowDropdown = isShowDropdown
        }
    }
};
</script>

<style lang="scss">
.sug-pc-place {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .desc {
        flex: 1 0 0;
        overflow: hidden;
        div {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    &.broker {
        .desc {
            font-size: 14px;
            color: #191919;
            text-align: right;
            margin-right: 5px;
        }
        .icon {
            .iconfont {
                margin-right: 0;
                color: #000;
            }
        }
    }
    &.standard {
        .desc {
            font-size: 16px;
            color: #515666;
            text-align: right;
            margin-right: 5px;
        }
        .icon {
            .iconfont {
                
                margin-right: 0;
            }
        }
    }
    &.template4 {
        .desc {
            font-size: 16px;
            color: #8b93a7;
            font-family: var(--font-medium);
            margin-right: 5px;
        }
        .icon {
            .icon-small-down {
                font-weight: bold;
                
            }
        }
    }
    .icon {
        transform-origin: 50% 50%;
        transition: transform 0.5s ease-in-out;
        &.rotate {
            transform: rotate(180deg);
        }
    }
}
</style>
